import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import { ShoppingCartOutlined, ShoppingOutlined } from '@ant-design/icons'
import { ProductListContext, OrderFormContext } from '../../contexts'

const Success = ({ visible }) => {
  const {
    setFormModalVisible
  } = useContext(ProductListContext)

  const {
    createAndStoreBatch
  } = useContext(OrderFormContext)

  const _onContinueShopping = () => {
    createAndStoreBatch()
    setFormModalVisible(false)
  }

  return visible
    ? (
      <div className="SuccessContainer">
        <p>Your items have been added to cart successfully.</p>
        <div className="SuccessContainer__ActionButtons">
          <Button type="primary" href="/cart" className="SuccessContainer__ActionButtons--button">
            <ShoppingCartOutlined className="cart-icon"/> View Cart
          </Button>
          <Button type="primary" onClick={_onContinueShopping} className="SuccessContainer__ActionButtons--button">
            <ShoppingOutlined className="cart-icon"/> Continue Shopping
          </Button>
        </div>
      </div>
    )
    : null
}

Success.propTypes = {
  visible: PropTypes.bool
}

export default Success
